import { ViewBooking } from "collins-js-sdk";
import React from "react";
import { DiaryContextType } from "../../../../../context/DiaryContext";
import { getBookingStatus } from "../../../../../utils/singleBooking";
import CustomPill from "../../../../Shared/CustomPill/CustomPill";
import { SelectedBookingTabEnum } from "../Tabs/SelectedBookingTabsController";

export const getBookingStatusIcon = (selectedBooking?: ViewBooking) => {
  if (!selectedBooking) {
    return <></>;
  }

  const bookingStatus = getBookingStatus(selectedBooking);
  return (
    <div style={{ width: "80px" }}>
      <CustomPill
        label={bookingStatus.label}
        backgroundColour={bookingStatus.colour}
        labelColour={bookingStatus.labelColour}
        softenColour={true}
      />
    </div>
  );
};

export const getBookingRefHyperlink = (
  booking: ViewBooking | undefined,
  diaryContext: DiaryContextType,
  setSelectedTabKey: ((value: SelectedBookingTabEnum) => void) | undefined,
  selectedTabKey?: SelectedBookingTabEnum
) => {
  const { selectedBooking, setDiaryContext, bookings } = diaryContext;
  const isCurrentBooking =
    selectedBooking && selectedBooking.reference === booking?.reference;

  const selectBooking = () => {
    if (isCurrentBooking) {
      return;
    }

    if (setSelectedTabKey) {
      setSelectedTabKey(selectedTabKey ?? SelectedBookingTabEnum.Manage);
    }

    const stateBooking = bookings?.find((b) => b.id === booking?.id);
    setDiaryContext({
      selectedBooking: stateBooking ?? booking,
      selectedBookingV4: undefined
    });
  };

  return (
    <button
      type="button"
      className={[
        "bg-transparent border-none p-0 cursor-pointer text-[var(--primaryColor)] underline",
        isCurrentBooking
          ? "DisableHyperlink no-underline opacity-50 cursor-default"
          : ""
      ]
        .filter(Boolean)
        .join(" ")}
      onClick={selectBooking}
    >
      {`DMN-${booking?.reference ?? ""}`}
    </button>
  );
};
